export default __webpack_public_path__ + "9fd9be16b876ef7807e4a7e65e450aff.svg";